 /**
 * 替换HTML模板中的动态值
 * @param {string} html - 原始HTML模板
 * @param {Object} replacements - 替换规则对象，键为占位符名称，值为替换的内容
 * @returns {string} 替换后的HTML
 */
export function replaceTemplateValues(html, replacements) {
    // 空模板是合法场景（接口未返回 HTML、仅 iframe 协议等），勿与 null/非字符串混淆
    if (html === '' || html == null) {
      return ''
    }
    if (typeof html !== 'string') {
      console.error('Invalid HTML template provided')
      return ''
    }
    
    if (!replacements || typeof replacements !== 'object') {
    console.error('Invalid replacements object provided');
    return html;
    }
    
    let result = html;
    
    // 遍历所有替换规则
    for (const key in replacements) {
    if (replacements.hasOwnProperty(key)) {
        // 创建正则表达式，匹配所有出现的占位符
        const regex = new RegExp(`{{${key}}}`, 'g');
        // 替换所有匹配项
        result = result.replace(regex, replacements[key]);
    }
    }
    
    return result;
}